<template>
  <v-main id="MainTable" style="max-width: unset" class="pa-0 ma-0">
    <HeaderProduct
      title="Produtos | Cadastro de Cupom "
      text="Inclua novos cupons e gerencie os cupons de desconto existentes"
      @voltar="$router.push('/coupons')"
      :haveBack="true"
    />

    <v-dialog v-model="sucessDialog" max-width="700px">
      <AprovalModal
        title="Incluir Cupom de desconto"
        :textMessage="
          'Tem certeza que deseja cadastrar ' +
          currentCoupon.code +
          ' como cupom?'
        "
        cancelBtn="Cancelar"
        okbtn="Confirmar"
        @close="sucessDialog = false"
        @action="submit(), (sucessDialog = false)"
      />
    </v-dialog>

    <v-dialog v-model="changeTypeDialog" max-width="700px">
      <AprovalModal
        title="Voltar e alterar o tipo"
        textMessage="Tem certeza que deseja alterar o tipo de cupom e perder o atual?"
        cancelBtn="Cancelar"
        okbtn="Confirmar"
        @close="changeTypeDialog = false"
        @action="(changeTypeDialog = false), goToCoupons()"
      />
    </v-dialog>

    <v-container style="max-width: unset" class="pa-6 pt-0">
      <v-card class="main-card mx-auto pa-0 pt-1" max-width="1328px">
        <v-form ref="form" v-model="firstValid" :key="clear" lazy-validation>
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 py-2 label-details">Código do Cupom</span>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon class="pa-0" color="#DADADA" v-bind="attrs" v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                <span>
                  <strong> Código Cupom </strong>
                  <br />
                  Informe somente letras e números.<br />
                  Exemplo: <strong> 150FFIMP </strong>
                </span>
              </v-tooltip>

              <v-text-field
                :disabled="isDetail"
                outlined
                class="input-novo px-0"
                v-model="currentCoupon.code"
                @input="currentCoupon.code = currentCoupon.code.toUpperCase()"
                oninput="javascript: if (this.currentCoupon.code.length > this.maxLength) this.currentCoupon.code = this.currentCoupon.code.slice(0, this.maxLength);"
                maxlength="25"
                hide-details
                height="52"
                placeholder="Código do Cupom"
                required
                :rules="[rules.required]"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <span class="ml-1 mb-2 label-details">Tipo de Beneficio</span>
              <v-select
                :disabled="isDetail"
                :items="status"
                v-model="currentCoupon.benefit"
                style="border-radius: 10px"
                hide-details
                clearable
                dark
                height="52"
                color="white"
                placeholder="% ou R$"
                background-color="normalred"
                item-text="label"
                item-value="value"
                outlined
                required
                :rules="[(v) => !!v || 'Item is required']"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="6" lg="6">
              <div
                v-if="
                  currentCoupon.benefit === 1 || currentCoupon.benefit == null
                "
              >
                <span class="ml-1 mb-2 label-details">Desconto(%)</span>
                <vuetify-money
                  :style="
                    currentCoupon.descontoPercentual < 1
                      ? 'border: 2px solid red; border-radius: 8px'
                      : 'border: 2px solid #979797; border-radius: 8px'
                  "
                  :disabled="isDetail"
                  v-bind:outlined="outlined"
                  background-color="#F5F5F5"
                  placeholder="0.00%"
                  hide-details
                  v-bind:options="optionsPercentagem"
                  v-model="currentCoupon.descontoPercentual"
                  required
                  :rules="[rules.required]"
                ></vuetify-money>
              </div>

              <div v-if="currentCoupon.benefit === 2">
                <span class="ml-1 mb-2 label-details">Desconto(R$)</span>
                <vuetify-money
                  v-bind:options="options"
                  outlined
                  :style="
                    currentCoupon.descontoReais < 1
                      ? 'border: 2px solid red; border-radius: 8px'
                      : 'border: 2px solid #979797; border-radius: 8px'
                  "
                  class="input-novo"
                  background-color="#F5F5F5"
                  hide-details
                  :rules="[rules.required]"
                  v-model="currentCoupon.descontoReais"
                ></vuetify-money>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <span class="label-details">Aplicado em:</span>
              <v-select
                :disabled="isDetail"
                :items="types"
                outlined
                v-model="currentCoupon.type"
                placeholder="Aplicação"
                class="input-novo"
                hide-details
                item-text="label"
                item-value="value"
                required
                :rules="[rules.required]"
              ></v-select>
            </v-col>

            <v-col cols="12" v-if="type == 3">
              <v-select
                :disabled="isDetail"
                :items="categories"
                outlined
                v-model="currentCoupon.categoryId"
                placeholder="Categoria"
                style="width: 410px"
                class="input-novo"
                hide-details
                item-text="categoryName"
                item-value="categoryId"
                required
                :rules="[rules.required]"
              ></v-select>
            </v-col>

            <v-col cols="12" v-if="type == 4">
              <v-select
                :disabled="isDetail"
                :items="subcategories"
                outlined
                v-model="currentCoupon.subCategoryId"
                placeholder="Sub-categoria"
                class="input-novo"
                style="width: 410px"
                hide-details
                item-text="name"
                item-value="subCategoryId"
                required
                :rules="[rules.required]"
              ></v-select>
            </v-col>

            <v-col cols="12" v-if="type == 5">
              <v-select
                :disabled="isDetail"
                :items="products"
                outlined
                v-model="currentCoupon.productId"
                placeholder="Produto"
                class="input-novo"
                hide-details
                style="width: 410px"
                item-text="productName"
                item-value="productId"
                required
                :rules="[rules.required]"
              ></v-select>
            </v-col>

            <v-col cols="12" v-if="type == 2">
              <span class="ml-1 mb-2 label-details">E-mail do cliente:</span>
              <v-text-field
                outlined
                class="input-novo px-0"
                placeholder="e-mail"
                style="width: 410px"
                hide-details
                :rules="[rules.required, rules.emailRules]"
                v-model="currentCoupon.email"
                required
              />
            </v-col>

            <v-col class="ma-1 pa-1" cols="12" sm="12" md="12" lg="12">
              <div class="copy-card ma-1 pa-1">
                <v-row
                  @click="copy('appToken')"
                  style="height: -webkit-fill-available; place-content: center"
                >
                  <v-col v-if="canCopy">
                    <div id="appToken">
                      <span>
                        <strong> Cupom: {{ this.currentCoupon.code }} </strong
                        ><br />
                        Esse cupom dá direito a
                        {{
                          this.currentCoupon.benefit == "2"
                            ? "R$ " + this.currentCoupon.descontoReais
                            : this.currentCoupon.benefit == null
                            ? ""
                            : this.currentCoupon.descontoPercentual + "%"
                        }}
                        de desconto em
                        {{
                          this.currentCoupon.type == 0
                            ? "produtos específicos"
                            : this.currentCoupon.type == 1
                            ? "toda a loja"
                            : this.currentCoupon.type == 2
                            ? "clientes selecionados"
                            : this.currentCoupon.type == 3
                            ? "uma categoria selecionada"
                            : this.currentCoupon.type == 4
                            ? "uma sub-categoria selecionada"
                            : this.currentCoupon.type == 5
                            ? "um produto especifico"
                            : "Não definido"
                        }}
                      </span>
                    </div>
                  </v-col>

                  <v-icon
                    @click.stop.prevent="generated()"
                    v-if="!canCopy"
                    class="pa-1 ma-1"
                    :key="componentKey"
                    style="font-size: xxx-large"
                    >{{ "mdi-reload" }}</v-icon
                  >
                  <v-icon
                    v-if="canCopy"
                    class="pa-3 ma-1"
                    style="font-size: xx-large"
                    >{{ "mdi-content-copy" }}</v-icon
                  >
                </v-row>
              </div>
              <div>
                <p class="label-dica">
                  Dica: Clique para gerar texto acima para copiar e usar para
                  divulgar o seu cupom.
                </p>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <div class="ma-0 py-3">Validade inicial(opcional):</div>
              <v-text-field
                v-model="dateFormatted"
                type="date"
                class="pa-0"
                style="border: 1px solid #979797; border-radius: 8px"
                background-color="#F5F5F5"
                :placeholder="invalidData ? ' Indeterminado' : ' DD/MM/AAAA'"
                hide-details
                outlined
                clearable
                height="52"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <div class="ma-0 py-3">Validade Final(opcional):</div>
              <v-text-field
                v-model="dateFormatted2"
                type="date"
                class="pa-0"
                style="border: 1px solid #979797; border-radius: 8px"
                background-color="#F5F5F5"
                :placeholder="invalidData ? ' Indeterminado' : ' DD/MM/AAAA'"
                :max="
                  new Date(
                    Date.now() + new Date().getTimezoneOffset() * 300000000
                  )
                    .toISOString()
                    .substr(0, 10)
                "
                hide-details
                outlined
                clearable
                height="52"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <div class="py-3">
                <span class="ml-1 mb-2 label-details"
                  >Pedido Mínimo(opcional):</span
                >
                <vuetify-money
                  :disabled="isDetail"
                  v-bind:options="options"
                  v-bind:outlined="outlined"
                  prefix="R$"
                  background-color="#C4C4C4"
                  hide-details
                  v-model="currentCoupon.minimum_price"
                  required
                ></vuetify-money>
              </div>
            </v-col>

            <v-col cols="12" sm="6" md="6" lg="6">
              <div class="py-3">
                <span class="ml-1 mb-2 label-details"
                  >Cupons disponíveis(opcional):</span
                >
                <v-text-field
                  :disabled="isDetail"
                  v-model="currentCoupon.quantity"
                  maxlength="5"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  class=""
                  outlined
                  background-color="#C4C4C4"
                  type="number"
                  placeholder="Ilimitado"
                  hide-details
                  required
                ></v-text-field>
              </div>
            </v-col>

            <v-col cols="12" sm="12" md="12" lg="12">
              <span class="ml-1 mb-2 label-details">Descrição do cupom*</span>
              <v-textarea
                height="80"
                :disabled="isDetail"
                outlined
                :rules="[rules.required]"
                hide-details
                v-model="currentCoupon.description"
                placeholder="Digite a descrição da promoção"
                class="input-novo"
                required
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row class="ma-0">
            <v-col cols="12" md="12" sm="6" lg="12">
              <div class="ma-0 pa-0">
                <span class="ml-1 mb-2 label-details"
                  >Datas disponíveis para uso</span
                >
                <v-row class="day-card ma-0 pa-0" elevation="0">
                  <v-list-item
                    class="pa-1"
                    v-for="(dia, idx) in DaysOfTheWeekCoupon"
                    :key="idx"
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox
                          class="v-iconq"
                          large
                          v-model="dia.selected"
                          :key="idx"
                          :input-value="active"
                        ></v-checkbox>
                      </v-list-item-action>
                      <span class="dias-semana">
                        {{ dia.day }}
                      </span>
                    </template>
                  </v-list-item>
                </v-row>
              </div>
            </v-col>
          </v-row>

          <v-row class="ma-0" justify="center">
            <v-col cols="12" sm="6" md="4" lg="2" class="d-flex justify-center">
              <v-btn
                :disabled="isDetail"
                class="cancel-button"
                outlined
                height="50"
                style="border-radius: 10px"
                @click="$router.push('/coupons')"
              >
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" class="d-flex justify-center">
              <v-btn
                :disabled="isDetail"
                class="primary-button d-flex justify-content-center"
                :loading="loading"
                @click="validate"
                >{{ isEditing ? "Alterar Cupom" : "Cadastrar Cupom" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<style scoped>
.v-text-field ::v-deep input {
  font-size: 15px !important;
}

.v-text-field ::v-deep label {
  font-size: 15px !important;
}

.v-text-field ::v-deep button {
  font-size: 15px !important;
}
.v-iconq {
  font-size: 110px;
}
.label-dica {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #979797;
  padding-left: 20px;
  padding-top: 10px;
}
.border-imput-nivel-1 {
  width: 60%;
  display: flex;
  align-items: center;
  background: #f5f5f5;
  box-sizing: border-box;
}
.border-imput-nivel-2 {
  border-bottom: 1px solid #979797;
  border-left: 1px solid #979797;
  border-top: 1px solid #979797;
  border-radius: 8px 0 0 8px;
}
.icon-input {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
  height: 58px;
  background: #e5e5e5;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 0 8px 8px 0;
}
.label-details {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #979797;
}
.input-escuro {
  border-radius: 7.5px;
  background: #c4c4c4;
  border-radius: 10px;

  color: black;
}
.pedido-minimo {
  background: #00cae3;
}
.input-novo {
  background-color: #f5f5f5;
  border-radius: 10px;
  color: black;
}
.copy-card {
  height: 100px;
  width: 48%;
  background: #f5f5f5;
  border: 1px dashed #979797;
  box-sizing: border-box;
  border-radius: 10px;
}
.copy-card:hover {
  cursor: pointer;
  color: #ffffff !important;
  background: #afadad;
  border: 1px solid #000000;
  box-sizing: border-box;
  border-radius: 10px;
}
.date-input {
  background: #f5f5f5;
}
.day-card {
  flex-wrap: nowrap;
  background: #f5f5f5;
  border: 1px solid #979797;
  box-sizing: border-box;
  border-radius: 10px;
  height: 118px;
}
.dias-semana {
  font-style: normal;
  font-weight: 300;
  font-size: 13px;
  color: #000000;
}
.red-label {
  align-self: center;
  text-align-last: right;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;

  letter-spacing: 0.15px;
  text-decoration-line: underline;
  color: #bc0000;
}
@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}
</style>

<script>
import ApiService from "../../../../services/ApiService";
import HeaderProduct from "../components/HeaderProduct/HeaderProduct.vue";
import AprovalModal from "../../components/AprovalModal.vue";
import { VMoney } from "v-money";
import Vue from "vue";
import { parseZone } from "moment";
import moment from "moment";
import "../../../../plugins/vuetify-money.js";

export default {
  components: {
    HeaderProduct,
    AprovalModal,
  },

  directives: { money: VMoney },

  data: () => ({
    categories: [],
    subcategories: [],
    products: [],
    type: null,
    types: [],
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
    pedidoMinimo: {
      background: "#00cae3",
    },
    outlined: true,
    heighta: 90,
    options: {
      locale: "pt-BR",
      prefix: "R$",
      suffix: "",
      length: 11,
      precision: 2,
    },
    optionsPercentagem: {
      locale: "pt-BR",
      suffix: "",
      length: 11,
      precision: 2,
      min: 10,
      max: 10,
    },
    maxLength: 25,
    dateFormatted: "",
    dateFormatted2: "",
    activePicker: null,
    activePicker2: null,
    date: null,
    date2: null,
    menu: false,
    menu2: false,
    descontoReais: null,
    invalidData: false,
    componentKey: false,
    canCopy: false,
    DaysOfTheWeekCoupon: [
      {
        day: "Domingo",
        selected: false,
        Validate_WeekDay: 0,
      },
      {
        day: "Segunda-feira",
        selected: false,
        Validate_WeekDay: 1,
      },
      {
        day: "Terça-feira",
        selected: false,
        Validate_WeekDay: 2,
      },
      {
        day: "Quarta-feira",
        selected: false,
        Validate_WeekDay: 3,
      },
      {
        day: "Quinta-feira",
        selected: false,
        Validate_WeekDay: 4,
      },
      {
        day: "Sexta-feira",
        selected: false,
        Validate_WeekDay: 5,
      },
      {
        day: "Sábado",
        selected: false,
        Validate_WeekDay: 6,
      },
    ],
    changeTypeDialog: false,
    status: [
      { label: "Percentual", value: 1 },
      { label: "Real", value: 2 },
    ],
    isEditing: false,
    currentCoupon: {
      code: "",
      descontoPercentual: 0,
      descontoReais: 0,
      benefit: null,
      type: 1,
      currentCoupon: null,
    },
    isDetail: false,
    firstValid: true,
    clear: false,
    sucessDialog: false,
    closeNoLoading: false,
    env_url: "",
    loading: false,
    page: 1,
    totalPages: 1,
    pageSize: 15,
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
    },
    rules: {
      nameRules: (v) =>
        (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",

      emailRules: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",

      required: (value) => !!value || "Campo requerido.",

      min: (v) => (v && v >= 4) || "Minimo de 4 caracteres.",
      minDes: (v) => (v && v > 0) || "Minimo de 4 caracteres.",

      /*minDesc: (v) => (v || "") >= 12 || "Minimo de 4 caracteres."*/
      /*validateCPF: (value) =>  (Utils.CPF(value) || value.toString().replace(/\D/g, "").length > 11) || 'Cpf Inválido',*/
    },
  }),

  async mounted() {
    if (this.$route.query.isEditing != null) {
      this.isEditing = true;
    }

    if (this.$route.query.id) {
      await this.apiService
        .get(`coupon/get-one?id=` + this.$route.query.id)
        .then((response) => {
          this.currentCoupon = response;
          this.currentCoupon.benefit = response.benefit;

          this.DaysOfTheWeekCoupon.forEach((x) => {
            x.selected =
              this.currentCoupon.daysOfTheWeekCoupon.find(
                (y) => y.validate_WeekDay === x.Validate_WeekDay
              ) != null;
          });
          if (this.currentCoupon.period === 2) {
            this.currentCoupon.period = true;
          } else {
            this.currentCoupon.period = false;
          }
          this.dateFormatted = this.currentCoupon.validate_initial
            ? moment(response.validate_initial).format("YYYY-MM-DD")
            : null;
          this.dateFormatted2 = this.currentCoupon.validate_end
            ? moment(response.validate_end).format("YYYY-MM-DD")
            : null;

          if (
            !this.currentCoupon.validate_initial &&
            !this.currentCoupon.validate_initial
          ) {
            this.invalidData = true;
            this.currentCoupon.period = true;
          }

          this.loading = false;

          this.type = this.currentCoupon.type;

          switch (this.currentCoupon.type) {
            case 1:
              this.types = [{ label: "Toda Loja", value: 1 }];
              break;
            case 2:
              this.types = [{ label: "Clientes Específicos", value: 2 }];
              break;
            case 3:
              this.types = [{ label: "Categoria específica", value: 3 }];
              break;
            case 4:
              this.types = [{ label: "Sub-categoria específica", value: 4 }];
              break;
            case 5:
              this.types = [{ label: "Produto específico", value: 5 }];
              break;

            default:
              break;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    }
  },

  async created() {
    this.type = this.$route.query.type;

    switch (this.type) {
      case "1":
        this.types = [{ label: "Toda Loja", value: 1 }];
        break;
      case "2":
        this.types = [{ label: "Clientes Específicos", value: 2 }];
        break;
      case "3":
        this.types = [{ label: "Categoria específica", value: 3 }];
        break;
      case "4":
        this.types = [{ label: "Sub-categoria específica", value: 4 }];
        break;
      case "5":
        this.types = [{ label: "Produto específico", value: 5 }];
        break;

      default:
        break;
    }

    this.currentCoupon.type = parseInt(this.type);
    this.env_url = process.env.VUE_APP_BASE_URL;

    this.getCategories();
    this.getProducts();
    this.getSubCategories();
  },

  computed: {
    desconto() {
      return (
        parseFloat(this.currentCoupon.descontoReais) +
        parseFloat(this.currentCoupon.descontoPercentual)
      );
    },
  },

  methods: {
    getCategories() {
      this.apiService.get("category/list").then((response) => {
        this.categories = response;
      });
    },

    getProducts() {
      this.apiService.get("product/listActiveWithStock").then((response) => {
        this.products = response.content;
      });
    },

    getSubCategories() {
      this.apiService.get("subCategory/listAll").then((response) => {
        this.subcategories = response;
      });
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.sucessDialog = true;
      }
    },

    generated() {
      if (
        this.$refs.form.validate() &&
        this.currentCoupon.code != null &&
        this.currentCoupon.benefit != null &&
        this.currentCoupon.type != null &&
        (this.currentCoupon.descontoReais ||
          this.currentCoupon.descontoPercentual)
      ) {
        this.canCopy = !this.canCopy;
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "Atenção",
          message: "Preencha todos os requisitos para gerar o cupom",
          trace: null,
        });
      }
    },
    async copy(id) {
      let s = document.getElementById(id).innerText;
      await navigator.clipboard.writeText(s);
      Vue.$globalEvent.$emit("onFlashMessage", {
        type: "success",
        title: "Cupom copiado!",
        message: "",
        trace: null,
      });
      this.componentKey = this.componentKey + 1;
    },

    invalidDate() {
      this.invalidData = !this.invalidData;
    },

    goToCouponsActive() {
      this.$router.push({
        path: "/coupons?actives=true",
        params: "",
      });
    },

    goToCoupons() {
      this.$router.push({
        path: "/coupons",
        params: "",
      });
    },

    async submit() {
      delete this.currentCoupon.daysOfTheWeekCoupon
      const model = {
        ...this.currentCoupon,
        Id: this.currentCoupon.id,
        Code: this.currentCoupon.code,
        Status: this.currentCoupon.status,
        Benefit: this.currentCoupon.benefit,
        UsedCoupons: [],
        Email: this.currentCoupon.email,
        DescontoPercentual: this.currentCoupon.descontoPercentual
          ? parseFloat(this.currentCoupon.descontoPercentual).toFixed(2)
          : null,
        DescontoReais: this.currentCoupon.descontoReais
          ? parseFloat(this.currentCoupon.descontoReais).toFixed(2)
          : null,
        Period: this.currentCoupon.period ? 0 : 1,
        Type: this.currentCoupon.type,
        Validate_initial: this.dateFormatted,
        Validate_end: this.dateFormatted2
          ? `${this.dateFormatted2} 23:59:59`
          : null,
        Minimum_price: this.currentCoupon.minimum_price
          ? parseFloat(this.currentCoupon.minimum_price).toFixed(2)
          : null,
        Validate_WeekDay: 0,
        Quantity: this.currentCoupon.quantity,
        Description: this.currentCoupon.description,
        DaysOfTheWeekCoupon: this.DaysOfTheWeekCoupon.filter((x) => x.selected),
      };
      model.UsedCoupons.push({
        email: this.currentCoupon.email,
        code: this.currentCoupon.code,
      });

      let url = "coupon/add";
      let mensagem = "Cupom cadastrado com sucesso";
      if (this.isEditing) {
        url = "coupon/edit";
        mensagem = "Cupom alterado";
      }
      this.apiService
        .post(url, model)
        .then((resp) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: mensagem,
            message: mensagem,
            trace: null,
          });

          this.loading = false;
          this.goToCouponsActive();
        })
        .catch((err) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "Erro ao cadastrar cupom",
            message: err.body.message,
            trace: null,
          });

          this.loading = false;
        });
    },

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    save(date) {
      this.$refs.menu.save(date);
    },
    save2(date) {
      this.$refs.menu2.save(date);
    },

    async goToRoute(route) {
      if (this.$route.path != route) {
        await this.$router.push(route);
      }
    },

    filterTable() {
      this.loading = true;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;

      this.updateTable();
      this.filterDialog = false;
    },
  },

  watch: {
    date2(val) {
      this.dateFormatted2 = this.formatDate(this.date2);
    },
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },

    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "YEAR"));
    },

    pageSize() {
      this.filter.pageSize = this.pageSize;
      this.updateTable();
    },

    page() {
      this.filter.page = this.page;
      this.updateTable();
    },
  },
};
</script>
